import { render, staticRenderFns } from "./HandleProductRequestSidebar.vue?vue&type=template&id=60f5938a&scoped=true&"
import script from "./HandleProductRequestSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleProductRequestSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleProductRequestSidebar.vue?vue&type=style&index=0&id=60f5938a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5938a",
  null
  
)

export default component.exports